module.exports = __webpack_public_path__ + "img/CDK20.5a6413d8.jpg";